import type { IHomeLoanCompareProductRepayment } from './HomeLoanCompareProductRepayment.interface';

export default class HomeLoanCompareProductRepayment
  implements IHomeLoanCompareProductRepayment {
  initialMonthlyRepayment: number;
  ongoingMonthlyRepayment: number;
  ongoingMonthlyRepaymentBuffer: number;
  upfrontFees: number;
  monthlyFees: number;
  annualFees: number;

  static build = (data: IHomeLoanCompareProductRepayment) =>
    new HomeLoanCompareProductRepayment(data);

  static blank = () => new HomeLoanCompareProductRepayment();

  /**
   * Constructor
   * @param {IHomeLoanCompareProductRepayment} data
   */
  constructor(data?: IHomeLoanCompareProductRepayment) {
    this.initialMonthlyRepayment = parseFloat(data?.initialMonthlyRepayment || 0);
    this.ongoingMonthlyRepayment = parseFloat(data?.ongoingMonthlyRepayment || 0);
    this.ongoingMonthlyRepaymentBuffer = parseFloat(data?.ongoingMonthlyRepaymentBuffer || 0);
    this.upfrontFees = parseFloat(data?.upfrontFees || 0);
    this.monthlyFees = parseFloat(data?.monthlyFees || 0);
    this.annualFees = parseFloat(data?.annualFees || 0);
  }
}
